export const NAME = 'contactHistory';

// Must be strings because of forms
export const SERVICES = {
	cancelingRequest: '26',
	serviceServices: '16',
	businessServices: '1',
};

export const quickFilter = {
	CANCEL_REQUEST: 'CANCEL_REQUEST',
	SERVICES_SERVICES: 'SERVICES_SERVICES',
	BUSINESS_SERVICES: 'BUSINESS_SERVICES',
};

export const formDataFieldsMap = {
	product: 'Produkt',
	service: 'Služba',
	serviceType: 'Typ služeb',
	contactType: 'Forma kontaktu s klientem',
	result: 'Výsledek',
	policyNo: 'Číslo PS',
	dateFrom: 'Datum komunikace od',
	dateTo: 'Datum komunikace do',
	quickFilterCancel: 'Žádost o storno',
	quickFilterServices: 'Servisní služby',
	quickFilterBusiness: 'Obchodní služby',
};

export const quickFilterTypesSetup = [
	{
		label: 'contactHistory:cancelRequestFilter',
		type: quickFilter.CANCEL_REQUEST,
	},
	{
		label: 'contactHistory:servicesFilter',
		type: quickFilter.SERVICES_SERVICES,
	},
	{
		label: 'contactHistory:businessServicesFilter',
		type: quickFilter.BUSINESS_SERVICES,
	},
];
